module.exports = __webpack_public_path__ + "static/img/7.b1e9dd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/eng/7.png
// module id = BiO7
// module chunks = 0